import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles } from '../style/gstheme';
import { createLengthWarning } from '../utils/utils';

const styles = Object.assign({}, globalStyles);
const fieldRegex = RegExp("^[^\"\\\\*{}<>#!'\\[\\]\\(\\)=£$%&|¬`¬]+$");

class NameField extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isValidPattern: true
        };
    }

    handleChange = (event) => {
        const t = event.target;
        let isValidPattern = t.value === "" || fieldRegex.test(t.value);
        this.setState({
            isValidPattern
        });
        this.props.onUpdate(t.value);
    };

    render() {

        const { text, classes, isReadOnly, label, margin, fullWidth, maxLength, readOnly, ariaLabel,
            error, errorText, isMandatory, dataTest, autoFocus } = this.props;
        const { isValidPattern } = this.state;

        return (
            <TextField
                value={text}
                variant="outlined"
                margin={margin}
                autoFocus={autoFocus}
                onChange={this.handleChange}
                style={{ marginTop: '0px' }}
                error={error || (isMandatory && text.toString().trim().length === 0)}
                label={label}
                readOnly={readOnly}
                fullWidth={fullWidth}
                placeholder="Enter text"
                FormHelperTextProps={{
                    "data-test": dataTest + "-helper-text"
                }}
                helperText={error && errorText ?
                    errorText
                    :
                    (!isValidPattern ?
                        (isMandatory && text.toString().trim().length === 0 ?
                            "This field cannot be empty."
                            :
                            "The text contains invalid characters."
                        )
                        :
                        createLengthWarning(text, this.props.maxLength)
                    )
                }
                InputProps={{
                    className: classes.inputLabel,
                    inputProps: {
                        ...(ariaLabel) && { "aria-label": ariaLabel },
                        "data-test": dataTest,
                        readOnly: isReadOnly,
                        maxLength: maxLength
                    }
                }
                } />
        );
    }
}

NameField.defaultProps = {
    isMandatory: true,
    margin: "dense",
    error: false,
    readOnly: false,
    errorText: null,
    autoFocus: false,
    fullWidth: false,
    maxLength: 100
};

NameField.propTypes = {
    classes: PropTypes.object,
    autoFocus: PropTypes.bool,
    dataTest: PropTypes.string,
    isMandatory: PropTypes.bool,
    error: PropTypes.bool,
    readOnly: PropTypes.bool,
    errorText: PropTypes.string,
    onUpdate: PropTypes.func,
    onDelete: PropTypes.func,
    fullWidth: PropTypes.bool,
    margin: PropTypes.oneOf(['normal', 'dense']),
    label: PropTypes.string
};

export default withStyles(styles)(NameField);